module.exports = __webpack_public_path__ + "img/formation.3d10a378.svg";